import {createAction} from '@ngrx/store';

export class NaseDialogActions {
  public static open = createAction('[Nase-Dialog] Open nase-dialog.');

  public static close = createAction('[Nase-Dialog] Close nase-dialog.');
}
